import {FormField} from "../form-field/form-field";

export class FormFieldRating extends FormField{
    getVal(){
        return this.$value.val();
    }

    setVal(val,noEvent){
        this.$value.val(val);
        this.findMember("item").removeClass("is-selected").filter("[data-value='"+val+"']").addClass("is-selected");
        for(var i = val; i > 0; i--){
            this.findMember("item").filter("[data-value='"+i+"']").addClass("is-selected");
        }
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");
        this.findMember("item").click(
            (ev) => {
                const value = $(ev.currentTarget).data("value");
                if(this.getVal()==value){
                    this.setVal("");
                }else{
                    this.setVal(value);
                }
            }
        );
    }
}
